import makeSlice from '@web/slices/reward/sliceMaker'

import {initOrderSheetByAPI, initResult} from '../../actions/familyPay'

const slice = makeSlice({
    extraReducers: (builder) => {
        builder
            .addCase(initOrderSheetByAPI.fulfilled, (state, {payload}) => {
                const {data} = payload

                state.products = data.products.map((product) => {
                    return {
                        itemId: product.productOrderNo,
                        imageUrl: product.productImageUrl,
                        name: product.productName,
                    }
                })
            })
            .addCase(initResult.fulfilled, (state, {payload}) => {
                state.benefitCardRewardTid = payload.benefitCardRewardTid ?? null
            })
    },
})

export default slice.reducer
